<template>
    <div class="form-group" :class="{row: inline && isLabelSlot, 'd-flex': inline && isLabelSlot}">
        <label v-if="isLabelSlot" :for="id" :class="labelClass" class="mb-0 mt-2">
            <slot name="label" />
        </label>
        <div :class="{ 'col-md-7': labelClass.length }">
            <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('Day') }}</span>
                </div>
                <select name="day" :id="day_id" class="form-control form-control-sm custom-green-input-bg" v-model="val[0]">
                    <option :value="day" v-for="day in 31" :key="day">{{ day }}</option>
                </select>
                <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('Month') }}</span>
                </div>
                <select name="month" :id="month_id" class="form-control form-control-sm custom-green-input-bg" v-model="val[1]">
                    <option :value="month" v-for="month in 12" :key="month">{{ month }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppDayMonthInput',
    props: {
        id: [String, Number],
        day_id: [String, Number],
        month_id: [String, Number],
        value: Array,
        inline: Boolean
    },
    computed: {
        val: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        labelClass() {
            if (this.inline) {
                return 'col-md-3 col-form-label text-md-right';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        }
    }
};
</script>

<style scoped></style>
